import React from 'react'
import Navbar from '../components/Navbar'
import Details from '../components/Product_Components/Details'
import Footer from '../components/Footer'



const Products = () => {
  return (
    <div>
      <Navbar/>
      <Details/>
      <Footer/>
    </div>
  )
}

export default Products